
export const MessageTypes = {
    MSG_INFO : {
        id: 1,
        label: 'MSG_INFO'
    },
    MSG_WARNING : {
        id: 2,
        label: 'MSG_WARNING'
    },
    MSG_ERROR : {
        id: 3,
        label: 'MSG_ERROR'
    }
};

